import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  GET_EXERCISE_BY_ID,
  GET_EXERCISE_BY_SEAT_SALE,
  GET_TICKET_BY_EXERCISEGROUP,
  GET_TICKET_FOR_EXERCISE_BY_SEATS,
  GET_ZONE_SCHEME_BY_EXERCISE
} from "../../../api/apiRoutes";
import { Assort } from "../../../models/Assort";
import { Exercise } from "../../../models/Exercise";
import { RowZone } from "../../../models/RowZone";
import { Seat } from "../../../models/Seat";
import { ZoneSeats } from "../../../models/ZoneSeats";
import { State } from "../../../store";
import getId from "../../../utils/getId";
import getObjectIds from "../../../utils/getObjectIds";
import useApiRequest from "../../../utils/hook/useApiRequest";
// import { TicketAccess } from "../../../models/TicketAccess";
import qs from "qs";
import { RouteComponentProps } from "react-router";
import { v4 as uuid } from "uuid";
import { TicketBillLine } from "../../../models/TicketBillLine";
import { setErrors } from "../../../store/alerts/alertsActions";
import { addTicketWithExerciseToBasket, selectExerciseBySeat } from "../../../store/basket/basketActions";
import useWithDispatch from "../../../utils/hook/withDispatchHook";

// const getTicketWithSeat = (assort: Assort, exercise: Exercise, rowZone: RowZone, seat: Seat) => {
//   return {
//     assort,
//     quantity: 1,
//     ticketAccessList: [{ exercise, status: "Added", seat, rowZone } as TicketAccess],
//     tempId: `${getId(seat)}`
//   } as TicketBillLine;
// };

const isBasket = (basket: TicketBillLine[], tempId: string) => {
  return basket.some(item => item.tempId === tempId);
};

const validateBasket = (basket: TicketBillLine[], tempId: string, exerciseMaxQnt: number) => {
  const item = basket.filter(item => item.tempId === tempId)[0];
  return item.quantity === exerciseMaxQnt;
};

declare const config: { EXERCISE_IDS_MANY_TICKET: string; MAX_EXERCISE_SALE: string };

export default function useSeatSale(props: RouteComponentProps) {
  const { post, get } = useApiRequest();
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(new Date());
  const [exerciseList, setExerciseList] = useState<Exercise[]>([]);
  const selectExercise = useSelector((state: State) => state.basket.exerciseSelect);
  const [ticketList, setTicketList] = useState<Assort[]>([]);
  const [selectedTicket, setSelectedTicket] = useState<Assort>({} as Assort);
  const [zoneScheme, setZoneScheme] = useState<ZoneSeats | null>(null);
  const [openTicketModal, setOpenTicketModal] = useState(false);
  const exerciseIds = qs.parse(props.location.search.slice(1)).exerciseIds as string;
  const [exercise, setExercise] = useState<Exercise>({} as Exercise);
  const witchDispatch = useWithDispatch();
  const [activeStep, setActiveStep] = useState(0);
  const basket = useSelector((state: State) => state.basket.basket);

  const getExerciseList = useCallback(async () => {
    setLoading(true);
    const { isError, result } = await post(GET_EXERCISE_BY_SEAT_SALE, {
      // fromDate: format(date, "yyyy-MM-dd"),
      // toDate: format(date, "yyyy-MM-dd"),
      refreshSecondScreen: false,
      internet: "T"
    });
    if (!isError) {
      setExerciseList(Boolean(result) ? result : []);
    }
    setLoading(false);
  }, [post, date]);

  useEffect(
    () => {
      if (exerciseIds !== config.EXERCISE_IDS_MANY_TICKET) {
        getExerciseList();
      }
    }, // eslint-disable-next-line
    [getExerciseList]
  );

  const onClickPlanSeat = async () => {
    if (exerciseIds === config.EXERCISE_IDS_MANY_TICKET) {
      const { result, isError } = await get(GET_EXERCISE_BY_ID(exerciseIds));
      if (!isError) {
        getTicketWithoutSeats(result);
      }
    } else {
      if (selectExercise.length > 0) {
        getZoneScheme();
      }
    }
  };

  const getTicket = async (seatIds: string) => {
    setLoading(true);
    const objectIds = exerciseIds !== undefined ? exerciseIds : getId(selectExercise[0]);
    const { result, isError } = await get(GET_TICKET_FOR_EXERCISE_BY_SEATS(objectIds, seatIds));
    if (!isError) {
      setTicketList(result);
      setOpenTicketModal(true);
    }
    setLoading(false);
  };

  const getTicketWithoutSeats = async (value: Exercise) => {
    setLoading(true);
    const { result, isError } = await post(GET_TICKET_BY_EXERCISEGROUP, {
      objectDb: value.exerciseGroup.objectDb,
      objectId: value.exerciseGroup.objectId
    });

    if (!isError) {
      setTicketList(result);
      setActiveStep(activeStep + 1);
    }
    setLoading(false);
  };

  const handleTicket = (ticket: Assort) => {
    setSelectedTicket(ticket);
    // getZoneScheme();
  };

  const getZoneScheme = async (zoneIds?: string) => {
    setLoading(true);
    const objectIds = getObjectIds(exerciseIds !== undefined ? exerciseIds : getId(selectExercise[0]));
    if (zoneIds) {
      const { result, isError } = await post(GET_ZONE_SCHEME_BY_EXERCISE, {
        exerciseDb: objectIds?.objectDb,
        exerciseId: objectIds?.objectId,
        zoneIds
      });

      if (!isError) {
        setZoneScheme(result);
      }
    } else {
      const { result, isError } = await post(GET_ZONE_SCHEME_BY_EXERCISE, {
        exerciseDb: objectIds?.objectDb,
        exerciseId: objectIds?.objectId
      });

      if (!isError) {
        setZoneScheme(result);
      }
    }

    setLoading(false);
  };

  const handleClickSeat = (rowZone: RowZone, seat: Seat) => {
    if (seat.status === "X") {
      getZoneScheme(getId(seat));
    } else {
      getTicket(getId(seat));
      // dispatch(addTicketWithSeatToBasket(getTicketWithSeat(selectedTicket, selectExercise[0], rowZone, seat)));
    }
  };

  const getExerciseById = async () => {
    if (exerciseIds) {
      const { result, isError } = await get(GET_EXERCISE_BY_ID(exerciseIds));
      if (!isError) {
        setExercise(result);
        witchDispatch(selectExerciseBySeat)(result);
      } else {
        witchDispatch(selectExerciseBySeat)({ objectDb: 0, objectId: 0 } as Exercise);
      }
      setActiveStep(activeStep + 1);
      if (exerciseIds !== config.EXERCISE_IDS_MANY_TICKET) {
        getZoneScheme();
      }
    }
  };

  const validateAddTicket = (ticket: TicketBillLine) => {
    if (getId(exercise) === config.EXERCISE_IDS_MANY_TICKET) {
      const qnt = basket.filter(item => getId(item.ticketAccessList[0].exercise) === config.EXERCISE_IDS_MANY_TICKET)
        .length;
      if (qnt < Number(config.MAX_EXERCISE_SALE)) {
        addTicket({ ...ticket, tempId: uuid() });
      } else {
        witchDispatch(setErrors)(["Na tą imprezę możesz wybrać jednorazowo 4 bilety."]);
      }
    } else {
      addTicket(ticket);
    }
  };

  const addTicket = (ticket: TicketBillLine) => {
    if (isBasket(basket, ticket.tempId)) {
      if (
        validateBasket(
          basket,
          ticket.tempId,
          ticket.ticketAccessList[0].exercise.capacity - ticket.ticketAccessList[0].exercise.reserved
        )
      ) {
        witchDispatch(setErrors)(["Brak miejsc na wybrany termin"]);
      } else {
        witchDispatch(addTicketWithExerciseToBasket)(ticket);
      }
    } else {
      witchDispatch(addTicketWithExerciseToBasket)(ticket);
    }
  };

  useEffect(() => {
    getExerciseById();
  }, [exerciseIds]);

  useEffect(() => {
    if (!openTicketModal) {
      document.body.style.overflow = '';
    }
  }, [openTicketModal]);


  return {
    loading,
    date,
    setDate,
    exerciseList,
    ticketList,
    selectedTicket,
    handleTicket,
    zoneScheme,
    handleClickSeat,
    onClickPlanSeat,
    openTicketModal,
    setOpenTicketModal,
    getZoneScheme,
    exercise,
    activeStep,
    setActiveStep,
    setTicketList,
    setZoneScheme,
    addTicket: validateAddTicket
  };
}
